import type { ParcelExitReminderState } from "../../config/parcelExitReminder";
import { NightAiScenarioIcon } from "./NightAiScenarioIcon";
import "./NightCards.css";

interface NightParcelExitReminderCardProps {
  reminder: ParcelExitReminderState;
  onDismiss: () => void;
  onOpenDetail: () => void;
}

export function NightParcelExitReminderCard({
  reminder,
  onDismiss,
  onOpenDetail
}: NightParcelExitReminderCardProps) {
  if (!reminder.visible) {
    return null;
  }

  const pendingCount = Math.max(1, reminder.pendingCount);
  const pickupPointName = reminder.pickupPointName || "家附近驿站";

  return (
    <section className="night-parcel-exit-reminder-card" aria-label="下车前取件提醒">
      <span className="night-parcel-exit-reminder-card__surface" aria-hidden="true" />
      <span className="night-ai-scenario-icon night-ai-scenario-icon--package night-parcel-exit-reminder-card__icon">
        <NightAiScenarioIcon icon="package" />
      </span>
      <div className="night-parcel-exit-reminder-card__main">
        <h2>下车前去取快递</h2>
        <p>{pickupPointName}还有{pendingCount}件待取，下车前记得去驿站取件。</p>
      </div>
      <div className="night-ai-expanded-card__actions night-parcel-exit-reminder-card__actions">
        <button type="button" className="night-ai-expanded-card__action night-ai-expanded-card__action--primary" onClick={onDismiss}>
          我知道了
        </button>
        <button type="button" className="night-ai-expanded-card__action night-ai-expanded-card__action--secondary" onClick={onOpenDetail}>
          查看详情
        </button>
      </div>
    </section>
  );
}
